"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeImpex_en_us = void 0;
function backofficeImpex_en_us() {
    return {
        "backoffice.impex.export.navigationtitle": "Data Export",
        "backoffice.impex.export.success.title": "Export successfully started",
        "backoffice.impex.export.success.message": "Your requested export was queued. You can continue working now, the work will be done as background task. We will send you an email when the export is finished.",
        "backoffice.impex.export.success.gototaskbtn": "Go to \"task queue\""
    };
}
exports.backofficeImpex_en_us = backofficeImpex_en_us;
